import { withInstall } from '../../../../utils/with-install'
import Tiles3D from './Tiles3D.vue'

export const ElAmapLayerTiles3d = withInstall(Tiles3D)
export default ElAmapLayerTiles3d
